'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 228 208",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M103.925.288C46.529.288 0 45.731 0 101.787c0 56.058 46.529 101.501 103.925 101.501 57.395 0 103.925-45.443 103.925-101.501",
    id: "robot-circled_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M103.925.288C46.529.288 0 45.731 0 101.787c0 56.058 46.529 101.501 103.925 101.501 57.395 0 103.925-45.443 103.925-101.501",
    id: "robot-circled_svg__c"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M103.925.288C46.529.288 0 45.731 0 101.787c0 56.058 46.529 101.501 103.925 101.501 57.395 0 103.925-45.443 103.925-101.501C207.85 45.731 161.32.288 103.925.288Z",
    id: "robot-circled_svg__e"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M103.925.288C46.529.288 0 45.731 0 101.787c0 56.058 46.529 101.501 103.925 101.501 57.395 0 103.925-45.443 103.925-101.501C207.85 45.731 161.32.288 103.925.288Z",
    id: "robot-circled_svg__g"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M103.925.288C46.529.288 0 45.731 0 101.787c0 56.058 46.529 101.501 103.925 101.501 57.395 0 103.925-45.443 103.925-101.501",
    id: "robot-circled_svg__i"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M103.925.288C46.529.288 0 45.731 0 101.787c0 56.058 46.529 101.501 103.925 101.501 57.395 0 103.925-45.443 103.925-101.501",
    id: "robot-circled_svg__k"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M103.925.288C46.529.288 0 45.731 0 101.787c0 56.058 46.529 101.501 103.925 101.501 57.395 0 103.925-45.443 103.925-101.501",
    id: "robot-circled_svg__m"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M103.925.288C46.529.288 0 45.731 0 101.787c0 56.058 46.529 101.501 103.925 101.501 57.395 0 103.925-45.443 103.925-101.501",
    id: "robot-circled_svg__o"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M103.925.288C46.529.288 0 45.731 0 101.787c0 56.058 46.529 101.501 103.925 101.501 57.395 0 103.925-45.443 103.925-101.501",
    id: "robot-circled_svg__q"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M103.925.288C46.529.288 0 45.731 0 101.787c0 56.058 46.529 101.501 103.925 101.501 57.395 0 103.925-45.443 103.925-101.501",
    id: "robot-circled_svg__s"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M103.925.288C46.529.288 0 45.731 0 101.787c0 56.058 46.529 101.501 103.925 101.501 57.395 0 103.925-45.443 103.925-101.501",
    id: "robot-circled_svg__u"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M103.925.288C46.529.288 0 45.731 0 101.787c0 56.058 46.529 101.501 103.925 101.501 57.395 0 103.925-45.443 103.925-101.501",
    id: "robot-circled_svg__w"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M103.925.288C46.529.288 0 45.731 0 101.787c0 56.058 46.529 101.501 103.925 101.501 57.395 0 103.925-45.443 103.925-101.501",
    id: "robot-circled_svg__y"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M103.925.288C46.529.288 0 45.731 0 101.787c0 56.058 46.529 101.501 103.925 101.501 57.395 0 103.925-45.443 103.925-101.501",
    id: "robot-circled_svg__A"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M103.925.288C46.529.288 0 45.731 0 101.787c0 56.058 46.529 101.501 103.925 101.501 57.395 0 103.925-45.443 103.925-101.501C207.85 45.731 161.32.288 103.925.288Z",
    id: "robot-circled_svg__C"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    id: "robot-circled_svg__E",
    d: "M0 207h227.475V.288H0z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M103.924 204c57.397 0 103.927-45.443 103.927-101.5S161.32 1 103.924 1C46.528 1 0 46.443 0 102.5S46.53 204 103.925 204",
    fill: "#E3EFF7"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(0 .712)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "robot-circled_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#robot-circled_svg__a"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M46.893 86.412a5.896 5.896 0 1 1-9.061-7.546 5.896 5.896 0 0 1 9.061 7.546M32.068 104.22a5.894 5.894 0 1 1-9.06-7.543 5.895 5.895 0 1 1 9.06 7.543m-.934-30.927c-3.02 3.628-3.982 8.285-3.022 12.56a14.587 14.587 0 0 0-11.803 5.247c-5.163 6.202-4.32 15.415 1.881 20.577 6.202 5.163 15.414 4.321 20.577-1.88a14.537 14.537 0 0 0 3.183-6.959l10.498 8.74a4.227 4.227 0 1 0 5.41-6.497l-10.476-8.72a14.542 14.542 0 0 0 6.21-4.372c5.162-6.2 4.321-15.413-1.88-20.576-6.202-5.163-15.415-4.32-20.578 1.88",
    fill: "#008ED1",
    mask: "url(#robot-circled_svg__b)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(0 .712)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "robot-circled_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#robot-circled_svg__c"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M65.607 88.855C63.978 96.6 85.658 120.89 94.994 127.75c9.335 6.86 42.95 14.45 53.863 15.306 10.913.855 3.933-26.007 3.933-26.007S70.002 67.965 65.607 88.855",
    fill: "#888790",
    mask: "url(#robot-circled_svg__d)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(0 .712)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "robot-circled_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#robot-circled_svg__e"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M116.92 207c4.67-22.86 16.523-47.28 19.193-53.199 3.578-7.935 2.043-14.307-5.036-19.447-7.08-5.14-13.849-10.787-28.174-20.795-9.346-6.532-26.887-9.56-37.947-10.876-6.333-.754-12.556 2.26-15.783 7.761-12.736 21.726-17.45 50.605-21.54 76.901a66.133 66.133 0 0 0-.735 7.194L116.921 207Z",
    fill: "#C0BFC9",
    mask: "url(#robot-circled_svg__f)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(0 .712)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "robot-circled_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#robot-circled_svg__g"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M43.879 194.54c.13-1.409.294-2.858.533-4.398 4.09-26.297 8.803-55.175 21.54-76.9 3.209-5.476 9.389-8.484 15.69-7.77-5.982-1.34-11.932-2.224-16.685-2.789-6.333-.754-12.557 2.26-15.783 7.761-12.736 21.727-17.45 50.605-21.54 76.901a66.133 66.133 0 0 0-.735 7.194h16.98Z",
    fill: "#FEFEFE",
    mask: "url(#robot-circled_svg__h)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(0 .712)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "robot-circled_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#robot-circled_svg__i"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M159.84 138.432c-6.174 3.978-11.477 8.847-21.379-1.75-9.903-10.597-22.805-28.902-42.61-34.737-19.805-5.835-37.85-8.152-26.975-19.22 10.875-11.069 21.9-23.454 29.346-29.772 7.444-6.317 21.837-11.736 44.218-5.052 22.381 6.685 42.888 29.44 44.538 44.135 2.242 19.98-20.965 42.418-27.139 46.396",
    fill: "#C0BFC9",
    mask: "url(#robot-circled_svg__j)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(0 .712)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "robot-circled_svg__l",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#robot-circled_svg__k"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M81.545 90.775c10.875-11.068 21.9-23.453 29.345-29.77 7.444-6.318 21.837-11.738 44.218-5.053 3.124.934 6.207 2.188 9.209 3.68-6.597-5.17-14.124-9.414-21.876-11.73-22.382-6.685-36.775-1.267-44.22 5.051-7.444 6.32-18.47 18.703-29.344 29.772-7.425 7.556-1.368 11.034 9.525 14.338.217-2.194 1.207-4.317 3.143-6.288",
    fill: "#FEFEFE",
    mask: "url(#robot-circled_svg__l)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(0 .712)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "robot-circled_svg__n",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#robot-circled_svg__m"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M131.597 59.912c-16.229-1.47-32.177 19.941-28.198 30.674 3.978 10.732 8.96 6.19 27.251 25.783 18.29 19.593 22.712 21.523 31.363 12.403s18.258-15.898 14.915-28.339c-3.343-12.442-23.458-38.54-45.33-40.52",
    fill: "#E3EFF7",
    mask: "url(#robot-circled_svg__n)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(0 .712)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "robot-circled_svg__p",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#robot-circled_svg__o"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M176.928 100.433c-3.168-11.791-21.399-35.83-41.913-40.002 19.058 5.976 35.438 27.982 38.426 39.099 3.342 12.442-6.263 19.22-14.915 28.34-3.316 3.495-6.012 5.359-9.104 5.236 4.744 2.148 8.1.4 12.591-4.333 8.651-9.12 18.258-15.898 14.915-28.34",
    fill: "#888790",
    mask: "url(#robot-circled_svg__p)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(0 .712)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "robot-circled_svg__r",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#robot-circled_svg__q"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M57.24 118.783c-.69 1.857-2.54 3.07-4.57 2.978-5.89-.267-17.96 1.008-22.519 15.011-6.699 20.578 22.612 32.86 47.943 30.965l1.815 7.61s-31.747 2.616-49.982-13.407c-18.236-16.022-8.14-40.87 8.69-46.745 5.963-2.082 10.837-2.557 14.337-2.47 3.187.077 5.37 3.143 4.286 6.058",
    fill: "#3D3B4A",
    mask: "url(#robot-circled_svg__r)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(0 .712)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "robot-circled_svg__t",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#robot-circled_svg__s"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M137.036 81.416a1.648 1.648 0 0 1-1.572 1.712l-10.091.433a1.65 1.65 0 0 1-1.713-1.573 1.648 1.648 0 0 1 1.572-1.712l10.09-.432a1.65 1.65 0 0 1 1.714 1.572",
    fill: "#3D3B4A",
    mask: "url(#robot-circled_svg__t)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(0 .712)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "robot-circled_svg__v",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#robot-circled_svg__u"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M130.633 88.39a1.648 1.648 0 0 1-1.712-1.572l-.432-10.091a1.648 1.648 0 0 1 1.572-1.712 1.65 1.65 0 0 1 1.713 1.572l.431 10.09a1.648 1.648 0 0 1-1.572 1.713",
    fill: "#3D3B4A",
    mask: "url(#robot-circled_svg__v)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(0 .712)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "robot-circled_svg__x",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#robot-circled_svg__w"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M164.322 106.463a1.65 1.65 0 0 1-1.572 1.713l-10.091.431a1.65 1.65 0 0 1-1.713-1.572 1.65 1.65 0 0 1 1.572-1.712l10.09-.431a1.65 1.65 0 0 1 1.714 1.572",
    fill: "#3D3B4A",
    mask: "url(#robot-circled_svg__x)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(0 .712)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "robot-circled_svg__z",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#robot-circled_svg__y"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M157.92 113.437a1.65 1.65 0 0 1-1.712-1.572l-.433-10.09a1.648 1.648 0 0 1 1.573-1.713 1.648 1.648 0 0 1 1.712 1.571l.431 10.092a1.649 1.649 0 0 1-1.57 1.712",
    fill: "#3D3B4A",
    mask: "url(#robot-circled_svg__z)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(0 .712)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "robot-circled_svg__B",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#robot-circled_svg__A"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M95.727 187.212a1.762 1.762 0 1 1-.66-3.462 1.762 1.762 0 0 1 .66 3.462m-11.35-38.502 5.918 37.737a5.343 5.343 0 1 0 10.49-1.997l-8.363-37.272c5.272-2.784 8.351-8.769 7.178-14.931a13.888 13.888 0 0 0-6.12-9.088l-2.779.53 1.791 9.408-6.004 5.44-7.349-2.897-1.79-9.409-2.78.528a13.89 13.89 0 0 0-2.353 10.702c1.173 6.161 6.236 10.596 12.161 11.249",
    fill: "#008ED1",
    mask: "url(#robot-circled_svg__B)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(0 .712)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "robot-circled_svg__D",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#robot-circled_svg__C"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M96.328 156.524s-8.828 1.732-14.24 3.102c-7.595 1.922-6.172 18.19 1.156 17.845 9.743-.461 20.35-5.148 20.35-5.148l-1.326-4.888-16.66 3.093v-5.533l11.354-4.046-.634-4.425Z",
    fill: "#3D3B4A",
    mask: "url(#robot-circled_svg__D)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(0 .712)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M226.206 92.88a3.81 3.81 0 0 0-3.084-.935c-1.506-2.178-4.024-5.174-7.868-7.897-6.364-4.51-17.715-9.072-35.642-5.19a1.23 1.23 0 1 0 .522 2.407c13.434-2.909 25.049-1.278 33.585 4.715a30.016 30.016 0 0 1 7.18 7.108c-.028.03-.057.056-.085.087a3.819 3.819 0 1 0 5.392-.294",
    fill: "#3D3B4A"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M118.916 192.93c-6.047-10.563 4.789-21.397 15.35-15.35a7.936 7.936 0 0 1 2.927 2.926c6.052 10.562-4.787 21.403-15.35 15.35a7.941 7.941 0 0 1-2.927-2.926m28.127-10.672h-2.454a17.097 17.097 0 0 0-1.934-4.49l1.789-1.787a.547.547 0 0 0 0-.776l-5.297-5.297a.55.55 0 0 0-.777 0l-1.898 1.9a17.033 17.033 0 0 0-4.378-1.73v-2.77a.55.55 0 0 0-.55-.55h-7.487a.55.55 0 0 0-.55.55v2.903a17.022 17.022 0 0 0-4.192 1.784l-2.086-2.087a.55.55 0 0 0-.776 0l-5.296 5.296a.549.549 0 0 0 0 .777l2.11 2.11a17.015 17.015 0 0 0-1.744 4.167h-2.965a.55.55 0 0 0-.55.55v7.488a.55.55 0 0 0 .549.549h2.88c.375 1.522.956 2.96 1.708 4.29l-1.988 1.988a.55.55 0 0 0 0 .777l5.295 5.295a.55.55 0 0 0 .777 0l1.877-1.877a17.036 17.036 0 0 0 4.4 1.909v2.568c0 .304.247.549.55.549h7.488c.304 0 .55-.245.55-.55v-2.435a17.016 17.016 0 0 0 4.59-1.851l1.687 1.689a.55.55 0 0 0 .775 0l5.297-5.297a.55.55 0 0 0 0-.777l-1.663-1.664a17.002 17.002 0 0 0 1.896-4.614h2.367a.55.55 0 0 0 .55-.55v-7.487a.55.55 0 0 0-.55-.55",
    fill: "#008ED1"
  }), /*#__PURE__*/React__namespace.createElement("mask", {
    id: "robot-circled_svg__F",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#robot-circled_svg__E"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#008ED1",
    mask: "url(#robot-circled_svg__F)",
    d: "M155.23 194.621h22.369v-8.271H155.23z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M170.212 187.657h-7.594v-21.563c0-1.6 1.297-2.897 2.897-2.897h1.8a2.897 2.897 0 0 1 2.897 2.897v21.563Z",
    fill: "#008ED1",
    mask: "url(#robot-circled_svg__F)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FEFEFE",
    mask: "url(#robot-circled_svg__F)",
    d: "m170.212 170.95-7.594-2.411v-2.014l7.594 2.412zM170.191 177.887l-7.594-2.412v-2.014l7.594 2.412zM170.212 184.575l-7.594-2.412v-2.015l7.594 2.412z"
  }))));
});
var RobotCircled = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.RobotCircled = RobotCircled;